// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"129":"registration","239":"poll","400":"yes-no","683":"rising-star","996":"info"}[chunkId] + ".style." + {"129":"46684007dbc1cb6dbc7e","239":"b6a154bdf63098167764","400":"55e895216e22d3848e75","683":"4655b691f29bfd71f541","996":"aafe0c20bc050d0480cc"}[chunkId] + ".css";
};